import { AddFavoriteChannel, RemoveFavoriteChannel } from '@tableau/search-microview-communication-channels';
import { ContentDefinitions } from '../models/contentDefinitions';
import { SearchResultItem } from '../models/SearchResultTypes';

export class FavoriteService {
  public static instance = new FavoriteService();

  public addFavorite(item: SearchResultItem): Promise<void> {
    const addFavoriteChannel = new AddFavoriteChannel();
    const getID = ContentDefinitions[item.contentType].getCustomFavoriteID;
    return addFavoriteChannel.call({ id: getID ? getID(item) : item.id, contentType: item.contentType }).data || Promise.reject();
  }

  public removeFavorite(item: SearchResultItem): Promise<void> {
    const removeFavoriteChannel = new RemoveFavoriteChannel();
    const getID = ContentDefinitions[item.contentType].getCustomFavoriteID;
    return removeFavoriteChannel.call({ id: getID ? getID(item) : item.id, contentType: item.contentType }).data || Promise.reject();
  }
}
